import { Link as LinkScroll } from 'react-scroll';
import styled from 'styled-components';
import { FaTimes } from 'react-icons/fa';
import { motion } from 'framer-motion';

const SidebarContainer = styled.aside`
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  background: #0d0d0d;

  display: grid;
  align-items: center;

  top: 0;
  left: 0;
  transition: 0.2s ease;
  transition-delay: ${({ isOpen }) => (isOpen ? '0' : '.6s')};
  opacity: ${({ isOpen }) => (isOpen ? '100%' : '0')};
  top: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
`;

const CloseIcon = styled(FaTimes)`
  color: #fff;

  &:hover {
    color: #dadada;
  }
`;

const Icon = styled.div`
  position: absolute;
  top: 1.2rem;
  right: 1.2rem;
  background: transparent;
  font-size: 2rem;
  outline: none;
  cursor: pointer;
`;

const SidebarWrapper = styled.div`
  color: #fff;
`;

const SidebarMenu = styled(motion.ul)`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(6, 60px);

  text-align: center;

  @media (min-width: 480px) {
    grid-template-rows: repeat(6, 80px);
  }
`;

export const MotionItems = styled(motion.li)``;

const SidebarLink = styled(LinkScroll)`
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 1.25rem;
  text-decoration: none;
  color: #fff;
  cursor: pointer;

  text-transform: uppercase;

  &:hover {
    color: #01bf71;
    transition: var(--transition-hover);
  }
`;

const SidebarButton = styled.div`
  display: flex;
  justify-content: center;
`;

export {
  SidebarContainer,
  CloseIcon,
  Icon,
  SidebarWrapper,
  SidebarMenu,
  SidebarLink,
  SidebarButton
};
